import i18n from "@/i18n";

export default [
  {
    path: "/account",
    name: "Account",
    component: () => import("@/pages/account/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].account.account.account,
      requireAuth: true,
      breadcrumb: [{ title: "account.account.account" }],
    },
  },
  {
    path: "/email",
    name: "ChangeEmail",
    component: () => import("@/pages/account/email.vue"),
    meta: {
      title: i18n.messages[i18n.locale].account.email.email,
      requireAuth: true,
      breadcrumb: [{ title: "account.account.account", name: "Account" }, { title: "account.email.email" }],
    },
  },
  {
    path: "/password",
    name: "ChangePassword",
    component: () => import("@/pages/account/password.vue"),
    meta: {
      title: i18n.messages[i18n.locale].account.password.password,
      requireAuth: true,
      breadcrumb: [{ title: "account.account.account", name: "Account" }, { title: "account.password.password" }],
    },
  },
  {
    path: "/bind",
    name: "Bind",
    component: () => import("@/pages/account/bind.vue"),
    meta: {
      title: i18n.messages[i18n.locale].account.bind.bind,
      requireAuth: true,
      breadcrumb: [{ title: "account.account.account", name: "Account" }, { title: "account.bind.bind" }],
    },
  },
];
